import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { Directory, Filesystem } from '@capacitor/filesystem';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';
import { sanitizeFileName } from '@wilson/utils';

@Injectable({
  providedIn: 'root',
})
export class NativeFileSaverHelperService {
  public async saveFile(
    blob: Blob,
    fileName: string,
    fileType: string,
  ): Promise<void> {
    if (Capacitor.isNativePlatform()) {
      if (Capacitor.getPlatform() === 'android') {
        let permissionStatus = await Filesystem.checkPermissions();
        if (permissionStatus.publicStorage !== 'granted') {
          permissionStatus = await Filesystem.requestPermissions();
        }
      }

      const base64Data = await this.convertBlobToBase64(blob);

      fileName = `${sanitizeFileName(fileName)}.${fileType}`;
      await Filesystem.writeFile({
        path: fileName,
        data: base64Data,
        directory: Directory.Documents,
      });

      const fileUri = await Filesystem.getUri({
        directory: Directory.Documents,
        path: fileName,
      });

      await FileOpener.openFile({
        path: fileUri.uri,
      });
    }
  }

  private convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = (): void => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }
}
